module.exports = __webpack_public_path__ + "img/avatar-male-1.0f009026.jpg";